import styled from 'styled-components';

const StyledFieldset = styled.div`
  && {
    cursor: not-allowed;
    background-color: #e5e5e5;
    opacity: 0.5;
    pointer-events: none;
  }
`;

export default StyledFieldset;
